<template>
  <document-page-template
    :document="documentSignature.document"
    :watermarks="watermarks"
    :loading="$loading.isLoading('getDocumentSignature')"
    @document-path="documentPath = $event">
    <template #top-header>
      <Header></Header>
    </template>

    <template #info>
      <div v-if="$loading.isLoading('getDocumentSignature')">
        <skeleton></skeleton>
      </div>
      <div v-else>
        <div class="info-block">
          <span class="info-block__label">Статус</span>
          <div class="info-block__value">
            {{ documentSignature.status.name }}
          </div>
        </div>

        <document-sign
          @sign="
            documentSignature.participants.push(...$event)
          "></document-sign>

        <div class="info-block">
          <span class="info-block__label">Автор</span>
          <div class="info-block__value">
            {{ getPersonName(documentSignature.author) }}
          </div>
        </div>
        <connected-document></connected-document>

        <SimpleExpansionPanel
          v-if="documentSignature.statusId !== 4"
          label="Доступ до документа">
          <client-access></client-access>
        </SimpleExpansionPanel>
      </div>
    </template>
  </document-page-template>
</template>

<script lang="ts">
import DocumentPageTemplate from '@/components/document-page-template/Index.vue'
import SimpleExpansionPanel from '@/components/expansion-panel/SimpleExpansionPanel.vue'
import Skeleton from '@/components/Skeleton.vue'

import ClientAccess from './sections/ClientAccess.vue'
import ConnectedDocument from './sections/ConnectedDocument.vue'
import DocumentSign from './sections/DocumentSign.vue'
import Header from './sections/Header.vue'

import { initDocumentSignature } from './index'
import { getPersonName } from 'best-modules/utils'

export default {
  name: 'DocumentSignatureSingle',
  components: {
    DocumentSign,
    ConnectedDocument,
    Skeleton,
    SimpleExpansionPanel,
    ClientAccess,
    DocumentPageTemplate,
    Header,
  },
  methods: { getPersonName },
  setup() {
    return { ...initDocumentSignature() }
  },
}
</script>

<style scoped lang="scss"></style>
